module.exports = __webpack_public_path__ + "static/media/logo_sqr.451fafc6.png";